import React from "react";

const LoadingNumber = () => (
  <div className="loading-number" role="status" aria-label="Loading result">
    <div className="loading-dot" />
    <div className="loading-dot" />
    <div className="loading-dot" />
  </div>
);

export default LoadingNumber;
